import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
export const ItemEmbellishmentChangeProductionTimeConfirmationPopup = allProps => {
  const {
    open,
    onCancel,
    onItemConfirm,
    storageType,
    item,
    methodId,
    productionTimeId
  } = allProps;
  const handleConfirm = () => {
    onItemConfirm(item, storageType, methodId, productionTimeId);
  };
  const handleCancel = () => {
    onCancel(item._id, storageType);
  };
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    title: "You are changing your decorating method",
    msg: "Your design may need adjustments based on the new decorating method. Are you sure you want to continue?",
    confirmText: "Continue",
    open: open,
    onConfirm: handleConfirm,
    onCancel: handleCancel
  });
};